interface AppConfig {
    [key: string]: string | number | undefined,

    basePath: string,
    contextPath: string,
    i18nSource: string
}

export const config: AppConfig = {basePath: '', contextPath: '', i18nSource: ''};
Object.keys(process.env).forEach((key: string) => {
    let key2 = key;
    if (key2.startsWith('REACT_APP_')) {
        key2 = key.substr('REACT_APP_'.length);
    }
    config[key2] = process.env[key];
});
Object.freeze(config);